export default Object.freeze({
  "MINUTE": "MNT",
  "LINEAR": "LIN",
  "BARCHAR": "BAR",
  "NUMERIC": "NUM"
});